import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
const OptimizePanelHeader = () => {
  return /*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.optimizeCanvas.header"
      })
    })
  });
};
export default OptimizePanelHeader;